export interface IMenuItem {
  id?: MenuItemType;
  icon: string;
  title: string;
  url: string;
  queryParams?: { [key: string]: any };
  iconBack?: string;
  iconClass?: string;
  cardStyle?: Partial<CSSStyleDeclaration>;
  iconStroke?: string
  onlySideMenu?: boolean;
  iconFill?: string;
  children?: IMenuItem[];
  isAdmin?: boolean;
}

export enum MenuItemType {
  MainMenu = 'MainMenu',
  Greenhouses = 'Greenhouses',
  Weather = 'Weather',
  CropMonitoring = 'CropMonitoring',
  CropIdentification = 'CropIdentification',
  FieldIdentification = 'FieldIdentification',
  CropYieldForecast = 'CropYieldForecast',
  ElectronicFieldMap = 'ElectronicFieldMap',
  SatelliteData = 'SatelliteData',
  Dictionaries = 'Dictionaries',
  Notifications = 'Notifications',
  Reports = 'Reports',
  UAV = 'UAV',
  Administration = 'Administration',
  WeatherAdministration = 'WeatherAdministration',
  SatelliteAdministration = 'SatelliteAdministration',
}
